export enum SELECT_PICKUP_POINT_STATES {
  INITIAL = 'INITIAL',
  GET = 'GET',
  POINTS_FETCHING = 'POINTS_FETCHING',
  GET_ERROR = 'ERROR',
  GET_SUCCESS = 'GET_SUCCESS',
  POINT_SELECTED = 'POINT_SELECTED',
  OPENED = 'OPENED',
  CLOSED = 'CLOSED',
}
